import { render, staticRenderFns } from "./DetailIssueDrawer.vue?vue&type=template&id=38b39659&"
import script from "./DetailIssueDrawer.vue?vue&type=script&lang=js&"
export * from "./DetailIssueDrawer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports